/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * État de blocage renvoyé par le back lorsqu'une opération annule des devis en cours (ex. profession à risque non couverte).
 * @export
 * @interface BlockingStateDto
 */
export interface BlockingStateDto {
    /**
     * Indique si l'opération est bloquée.
     * @type {boolean}
     * @memberof BlockingStateDto
     */
    isBloque: boolean;
    /**
     * Raison du blocage (ex. "riskProfession"). Volontairement libre pour rester forward-compatible avec de futures raisons.
     * @type {string}
     * @memberof BlockingStateDto
     */
    reason: string;
    /**
     * Message utilisateur prêt à afficher (déjà localisé côté back).
     * @type {string}
     * @memberof BlockingStateDto
     */
    message: string;
    /**
     * Ids des devis annulés par l'action déclenchante.
     * @type {Array<string>}
     * @memberof BlockingStateDto
     */
    cancelledQuoteIds?: Array<string>;
}

/**
 * Check if a given object implements the BlockingStateDto interface.
 */
export function instanceOfBlockingStateDto(value: object): value is BlockingStateDto {
    if (!('isBloque' in value) || value['isBloque'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function BlockingStateDtoFromJSON(json: any): BlockingStateDto {
    return BlockingStateDtoFromJSONTyped(json, false);
}

export function BlockingStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlockingStateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isBloque': json['isBloque'],
        'reason': json['reason'],
        'message': json['message'],
        'cancelledQuoteIds': json['cancelledQuoteIds'] == null ? undefined : json['cancelledQuoteIds'],
    };
}

export function BlockingStateDtoToJSON(json: any): BlockingStateDto {
    return BlockingStateDtoToJSONTyped(json, false);
}

export function BlockingStateDtoToJSONTyped(value?: BlockingStateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isBloque': value['isBloque'],
        'reason': value['reason'],
        'message': value['message'],
        'cancelledQuoteIds': value['cancelledQuoteIds'],
    };
}

